import * as types from '../types'

const initialState = {
    // Catálogo inteiro — fluxo antigo, mantido para quem ainda chama
    // getAllMaterialsReduced sem filtro de marca.
    materials: [],
    isLoading: true,

    // Fluxo por marca: a tela carrega a lista de marcas no mount e busca os
    // materiais de cada marca conforme o usuário vai marcando.
    brands: [],
    isBrandsLoading: true,
    byBrand: {},
    loadingBrands: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case types.GET_ALL_MATERIALS_REDUCED_SUCCESS: {
            const newState = { ...state }
            newState.materials = action.payload.data.materials
            newState.isLoading = false
            return newState
        }
        case types.GET_MATERIAL_BRANDS_SUCCESS: {
            return { ...state, brands: action.payload, isBrandsLoading: false }
        }
        case types.GET_MATERIALS_BY_BRANDS: {
            return {
                ...state,
                loadingBrands: [...state.loadingBrands, ...action.payload],
            }
        }
        case types.GET_MATERIALS_BY_BRANDS_SUCCESS: {
            const { brands, materials } = action.payload
            const byBrand = { ...state.byBrand }

            // Toda marca pedida ganha uma entrada, mesmo sem material: é o que
            // diferencia "já carregada e vazia" de "ainda não carregada".
            brands.forEach((b) => { byBrand[b] = [] })
            materials.forEach((m) => {
                if (byBrand[m.brand]) byBrand[m.brand].push(m)
            })

            return {
                ...state,
                byBrand,
                loadingBrands: state.loadingBrands.filter(
                    (b) => !brands.includes(b)
                ),
            }
        }
        case types.INVALIDATE_MATERIALS_CACHE: {
            return { ...state, byBrand: {}, loadingBrands: [] }
        }
        default: {
            return state;
        }
    }
}
